/* global game, Phaser */

// https://photonstorm.github.io/phaser-ce/index.html
//

/**
 * TODO
 *
 * add cheering and whooping at the end of the race
 *
 *
 * STRETCH GOALS
 *
 * turbo if you press down when the light turns green
 * add jumping animations
 * hit a snowman and watch it explode
 * grind on fallen trees/ pipes/ bars
 * small bumps that make you jump
 * stunts
 * more levels
 * display a 'click to continue' message when the game loses focus
 * more tree designs
 * zonal audio. Different sounds in different areas of the map
 *  - cheering at the finish line
 *  - water at the rivers
 *  - birds tweeting through the trees
 *  - cowbells and cheering
 *
 *
 *
 * FUTURE IDEAS FOR FULL VERSION
 *
 * different surfaces
 * - ice
 * - grass
 * - gravel
 * - stone
 * - rock
 * caves
 * houses
 * chair lift
 * drone to rescue you when you drown/ hit a tree
 * change clothing colour
 * moving obstacles? Boulders/ giat snowballs?
 * animals
 * holes & pits to avoid
 * arcade.skipQuadTree - is it helpful for tilemap when there are lots of potential player to player collisions?
 */


var playState = {

	debug: false,

	debug_tile: {},

	debug_player: {},

	player: null,

	player_image: null,

	player_shadow: null,

	player_speed: 0,

	player_height: 0,

	player_animation: 'down',

	player_old_height: 0,

	player_trail: null,

	player_trail_frame: 0,

	finish_region: {},

	start_region: {},

	game_over_panel: null,

	game_start_panel: null,

	tile_size: 8,

	half_tile_size: 4,

	width: 8,

	height: 256,

	home_location: null,

	game_state: 'play',

	audio_jump: null,

	audio_crash: null,

	audio_turn: null,

	audio_lose: null,

	audio_countdown: null,

	audio_win: null,

	audio_wind: null,

	audio_theme: null,

	audio_weeeee: null,

	font_set: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,;:?!-_\'#"\\/<>()@',

	confetti: null,

	game_start_time: 0,

	game_time: 0,

	// Tile id for left side only collision tile.
	LEFT_WALL: 1021,

	// Tile id for right side only collision tile.
	RIGHT_WALL: 1022,


	// Number of pixels above the collision object you need to be in order to trigger a collision.
	TILE_COLLISION_OFFSET: -2,

	// Top collision tile.
	TILE_COLLISION: 1023,

	// Water tile.
	TILE_WATER: 989,

	/**
	 * Create game world
	 */
	create: function() {

		game.sound.stopAll();

		// add object groups - used for looping through objects and for setting z-order
		this.groupLevel = this.add.group();
		this.groupElements = this.add.group();
		this.groupHud = this.add.group();


		// fix hud to camera
		this.groupHud.fixedToCamera = true;


		// setup arcade physics
		game.physics.startSystem( Phaser.Physics.ARCADE );
		game.physics.arcade.TILE_BIAS = 8;


		// cursor controls

		this.cursor = this.game.input.keyboard.createCursorKeys();
		this.space = this.game.input.keyboard.addKey( Phaser.Keyboard.SPACEBAR );


		// setup player
		this.player = this.game.add.sprite( 0, 0, null );
		this.player.anchor.setTo( 0, 0 );
		this.player.gravity = 0;
		this.player.alive = true;

		game.physics.enable( this.player, Phaser.Physics.ARCADE );
		//this.player.body.setCircle( 3, -3, -1 );
		this.player.body.setSize( 4, 4, -2, -6 );

		this.player.body.tilePadding.set( 12, 12 );
		this.player.body.collideWorldBounds = true;

		this.player.z = 0;
		this.player.body.velocity.z = 0;

		this.groupElements.add( this.player );


		// player shadow

		this.player_shadow = this.game.add.sprite( 0, 0, 'player' );
		this.player_shadow.anchor.setTo( 0.5, 1 );
		this.player_shadow.frame = 17;

		this.groupElements.add( this.player_shadow );


		// Ski trail
		this.player_trail = game.add.emitter( 0, 0, 0 );
		this.player_trail.makeParticles( 'ski-trail', 0, 30 );
		this.player_trail_frame = 0;

		this.player_trail.setXSpeed( 0, 0 );
		this.player_trail.setYSpeed( 0, 0 );
		this.player_trail.setRotation( 0, 0 );
		this.player_trail.setAlpha( 1, 0.1, 1000 );
		this.player_trail.gravity = 0;
		this.player_trail.start( false, 1000, 35 );

		this.groupElements.add( this.player_trail );


		// player animations
		this.player_image = this.game.add.sprite( 0, 0, 'player' );
		this.player_image.anchor.setTo( 0.5, 1 );

		this.player_image.animations.add( 'down', [ 0, 1, 2 ], 4, true );
		this.player_image.animations.add( 'up', [ 3, 4, 5 ], 4, true );
		this.player_image.animations.add( 'right-2', [ 6, 7, 8 ], 4, true );
		this.player_image.animations.add( 'left-2', [ 9, 10, 11 ], 4, true );
		this.player_image.animations.add( 'right-1', [ 33, 34, 35 ], 4, true );
		this.player_image.animations.add( 'left-1', [ 36, 37, 38 ], 4, true );
		this.player_image.animations.add( 'slow', [ 12 ], 4, true );
		this.player_image.animations.add( 'die', [ 13, 14, 15, 16 ], 6, false );
		this.player_image.animations.add( 'drown', [ 18, 19, 20, 21, 22, 23, 24, 25 ], 12, false );
		this.player_image.animations.add( 'celebrate', [ 26, 27, 28, 29 ], 5, true );
		this.player_image.animations.add( 'fast', [ 30 ], 4, true );
		this.player_image.animations.add( 'fast_right', [ 31 ], 4, true );
		this.player_image.animations.add( 'fast_left', [ 32 ], 4, true );

		this.groupElements.add( this.player_image );


		// Hud
		this.hud = this.game.add.sprite( 0, 0, 'hud' );
		this.groupHud.add( this.hud );

		this.game_over_panel = this.game.add.sprite( 0, 64, 'game-over' );
		this.game_over_panel.inputEnabled = true;
		this.game_over_panel.events.onInputDown.add( this.game_over_input, this );

		this.groupHud.add( this.game_over_panel );

		this.game_start_panel = this.game.add.sprite( 0, 64, 'game-start' );
		// Coundown animation - does not loop!
		this.game_start_panel.animations.add( 'countdown', [ 0, 1, 2, 3 ], 1, false );

		this.groupHud.add( this.game_start_panel );



		// timer
		this.timer_text = this.game.add.retroFont( 'font', 4, 6, this.font_set, 8, 3, 1, 2, 1 );
		this.timer_text.text = '00:00';
		this.timer_image = this.game.add.image( this.width, 1, this.timer_text );
		this.timer_image.anchor.setTo( 1, 0 );
		this.timer_image.x = this.game.width;

		this.groupHud.add( this.timer_image );

		this.distance_text = this.game.add.retroFont( 'font', 4, 6, this.font_set, 8, 3, 1, 2, 1 );
		this.distance_text.text = '000';
		this.distance_image = this.game.add.image( this.width, 1, this.distance_text );
		this.distance_image.anchor.setTo( 0, 0 );
		this.distance_image.x = 1;

		this.groupHud.add( this.distance_image );


		// Audio
		this.audio_wind = game.add.audio( 'wind' );
		this.audio_wind.loopFull();

		this.audio_theme = game.add.audio( 'theme' );
		this.audio_jump = game.add.audio( 'jump-land' );
		this.audio_jump.volume = 1.5;
		this.audio_crash = game.add.audio( 'crash' );
		this.audio_crash.volume = 1.5;
		this.audio_splash = game.add.audio( 'splash' );
		this.audio_turn = game.add.audio( 'ski-turn' );
		this.audio_win = game.add.audio( 'win' );
		this.audio_lose = game.add.audio( 'lose' );
		this.audio_countdown = game.add.audio( 'countdown' );
		this.audio_weeeee = game.add.audio( 'weeeeee' );
		this.audio_weeeee.volume = 0.8;

		// reset settings
		this.camera = { x: 0, y: 0 };
		this.player_speed = 20;
		this.game_state = 'countdown';


		// If debug
		if ( this.debug ) {

			this.debug_tile = new Phaser.Rectangle( 0, 0, this.tile_size, this.tile_size );
			this.debug_player = new Phaser.Rectangle( 0, 0, 2, 2 );

		}

		// load level
		this.load_map();

		this.do_countdown();

	},


	/**
	 * Update game
	 */
	update: function() {

		switch ( this.game_state ) {

			// Countdown before race begins.
			case 'countdown':

				break;

			// RACE!
			case 'play':

				this.player_movements();
				this.timer_update();
				this.distance_update();
				this.check_finish();

				// Do collision after everything else otherwise they could reset properties.
				game.physics.arcade.collide( this.player, this.layer_collision, this.player_collision_callback, this.player_collision_check, this );

				// Modify things based on terrain properties.
				game.physics.arcade.overlap( this.player, this.layer_heights, this.player_heights_callback, null, this );

				break;

			// You win! :)
			case 'win':

				this.game_win();

				break;

			// Loser!
			case 'lose':

				if ( this.space.isDown ) {

					game.state.start( 'play' );

				}

				break;

		}

		// Always do these...

		// Camera always follows player.
		this.camera_movements();

		// Update game properties.
		this.game_update();

	},


	/**
	 * Do the countdown before the race begins.
	 */
	do_countdown: function() {

		var tween_in = game.add.tween( this.game_start_panel ).to(
			{ y: 64 - this.game_start_panel.height },
			1000,
			Phaser.Easing.Bounce.Out,
			true
		);

		tween_in.onComplete.add(
			function() {

				this.game_start_panel.animations.play( 'countdown' );
				//this.audio_countdown.volume = 0.5;

			},
			this
		);

		game.time.events.add(
			1700,
			function() {
				this.play_once( this.audio_countdown );
			},
			this
		);

		game.time.events.add(
			Phaser.Timer.SECOND * 4,
			this.start_game,
			this
		);

	},


	/**
	 * Start the race and set all relevant variables.
	 */
	start_game: function() {

		game.add.tween( this.game_start_panel ).to(
			{ y: 64 },
			500
		).start();

		this.audio_theme.loopFull();

		this.game_state = 'play';

		this.game_start_time = this.game.time.totalElapsedSeconds();

	},


	/**
	 * Check for game end condition.
	 * @return {[type]} [description]
	 */
	check_finish: function() {

		// Check if the player is in the finish zone.
		if ( this.player.x > this.finish_region.x && this.player.x < this.finish_region.x + this.finish_region.w ) {
			if ( this.player.y > this.finish_region.y && this.finish_region.y < this.finish_region.y + this.finish_region.h ) {

				this.audio_theme.fadeOut();
				this.play_once( this.audio_win );

				this.game_state = 'win';
				this.game_win();
				this.house_party();

				this.game_over_panel.frame = 0;

				game.add.tween( this.game_over_panel ).to(
					{ y: 64 - this.game_over_panel.height },
					1100,
					Phaser.Easing.Bounce.Out,
					true
				);

			}
		}

	},


	/**
	 * Score Share Button
	 */
	share_button: function( message ) {

		// replace [distance] with distance travelled
		message = message.replace( '[distance]', this.get_distance_travelled() );
		// replace [time-elapsed] with time
		message = message.replace( '[time-elapsed]', this.get_time_elapsed() );

		var url = 'https://twitter.com/intent/tweet';
		url += '?text=' + encodeURI( message ) + ' -';
		url += '&via=binarymoon';
		url += '&url=' + encodeURI( 'https://binarymoon.itch.io/pixel-peak/' );

		window.open( url, '_blank' );

	},


	/**
	 * Update the clock
	 */
	timer_update: function() {

		this.game_time = this.game.time.totalElapsedSeconds();

		this.timer_text.text = this.get_time_elapsed();

	},


	/**
	 * Update the distance travelled.
	 */
	distance_update: function() {

		var distance = '000' + this.get_distance_travelled();

		this.distance_text.text = distance.substr( -3 );

	},


	/**
	 * Get the distance travelled.
	 */
	get_distance_travelled: function() {

		var total_distance = ( this.finish_region.finish_line - this.start_region.start_line ) / 8;
		var distance_travelled = Math.ceil( ( this.player.y - this.start_region.start_line ) / 8 );

		if ( distance_travelled < 0 ) {
			distance_travelled = 0;
		}

		if ( distance_travelled > total_distance ) {
			distance_travelled = total_distance;
		}

		return distance_travelled;

	},

	/**
	 * Get the elapsed time.
	 *
	 * @return string
	 */
	get_time_elapsed: function() {

		var seconds_elapsed = Math.round( this.game_time - this.game_start_time );

		return this.time_format( seconds_elapsed );

	},


	/**
	 * Format a time into minutes and seconds
	 *
	 * @param   {string} s Time in seconds
	 * @returns {string} A nicely formatted string showing the time remaining
	 */
	time_format: function( s ) {

		var minutes = '0' + Math.floor( s / 60 );
		var seconds = '0' + ( s - minutes * 60 );

		return minutes.substr( -2 ) + ':' + seconds.substr( -2 );

	},


	/**
	 * Position player shadow based upon player image location.
	 */
	shadow_movements: function() {

		this.player_shadow.x = this.player_image.x;
		this.player_shadow.y = this.player_image.y + this.player.z;

	},


	/**
	 * Position camera based upon users position
	 */
	camera_movements: function() {

		game.camera.x = this.player.x - 32;
		game.camera.y = this.player.y - 20;

	},


	/**
	 * Controls for player jumping.
	 */
	controls_jumping: function() {

		// reset velocity
		var x_speed = 1;
		this.player.body.velocity.y += 0.3;

		if ( this.cursor.left.isDown ) {

			this.player.body.velocity.x -= x_speed;
			// Add left jumping animation.

		} else if ( this.cursor.right.isDown ) {

			this.player.body.velocity.x += x_speed;
			// Add right jumping animation.

		}

	},


	/**
	 * Controls for player jumping.
	 */
	controls_fast: function() {

		// reset velocity
		var x_speed = 2;
		this.player.body.velocity.y += 0.9;
		this.player_animation = 'fast';

		if ( this.cursor.left.isDown ) {

			this.player.body.velocity.x -= x_speed;
			this.player_animation = 'fast_left';

		} else if ( this.cursor.right.isDown ) {

			this.player.body.velocity.x += x_speed;
			this.player_animation = 'fast_right';

		}

	},


	/**
	 * Controls for player jumping.
	 */
	controls_default: function() {

		// default properties
		var x_speed = this.player.body.velocity.y / 10;
		this.player_animation = 'down';

		// reset velocity
		this.player.body.velocity.y += 0.3;

		// take care of character movement
		// Slow down.
		if ( this.cursor.up.isDown ) {

			this.player.body.velocity.y = this.player.body.velocity.y * 0.95;

			this.player_animation = 'slow';

		}

		if ( this.cursor.left.isDown ) {

			this.player.body.velocity.x -= x_speed;

			this.player_animation = 'left';

			this.play_once( this.audio_turn );

		} else if ( this.cursor.right.isDown ) {

			this.player.body.velocity.x += x_speed;

			this.player_animation = 'right';

			this.play_once( this.audio_turn );

		}

		if ( this.cursor.left.isDown || this.cursor.right.isDown ) {

			var speed = Math.abs( this.player.body.velocity.x );

			if ( speed > 32 ) {
				this.player_animation += '-2';
			} else {
				this.player_animation += '-1';
			}

		}


	},


	/**
	 * Move player
	 */
	player_movements: function() {

		if ( 'play' !== this.game_state ) {
			return;
		}

		if ( this.player.z > 0 ) {
			this.controls_jumping();
		} else if ( this.cursor.down.isDown ) {
			this.controls_fast();
		} else {
			this.controls_default();
		}

		// Height related stuff.
		// Specifically - jumping!
		if ( this.player_old_height > this.player_height ) {
			this.player.z = this.player_old_height * this.half_tile_size;
		}

		// store old height.
		this.player_old_height = this.player_height;

		// update velocities.
		this.player.body.velocity.x = this.player.body.velocity.x * 0.95;
		this.player.body.velocity.y = this.player.body.velocity.y * 0.99;
		this.player.body.velocity.z -= 0.01;

		// Store old y velocity to help with collisions.
		this.player.body.velocity.old_y = this.player.body.velocity.y;

		// Play a landing sound if the player is about to land on the floor.
		if ( this.player.z > 0 && this.player.z + this.player.body.velocity.z <= 0 ) {
			this.play_once( this.audio_jump );
		}

		// Update player height.
		this.player.z += this.player.body.velocity.z;

		if ( this.player.z < 0 ) {
			this.player.z = 0;
			this.player.body.velocity.z = 0;
		}

		// Move player into a specific column to try and reduce clipping tile edges.
		var new_x = Math.round( this.player.x / this.half_tile_size ) * this.half_tile_size;
		this.player.body.velocity.x -= ( ( this.player.x - new_x ) / 2 );

		this.player_image.animations.play( this.player_animation );

		// update ski trail.
		// enable trail.
		this.player_trail.on = true;

		// default audio volumes.
		this.audio_theme.volume = 0.6;
		this.audio_wind.volume = 1;

		// if in the air then disable trail.
		if ( this.player.z > 0 ) {

			this.player_trail.on = false;
			this.audio_theme.volume = 0.3;
			this.audio_wind.volume = 2;

		}

	},


	/**
	 * Play a sound effect once.
	 *
	 * @param  object audio The sound to play.
	 */
	play_once: function( audio ) {

		// Quit if currently playing the sound.
		if ( audio.isPlaying ) {
			return;
		}

		audio.play();

	},


	/**
	 * Do stuff when there's a collision
	 */
	player_collision_callback: function( player, tile ) {

		// Game is over so no need to continue.
		if ( 'play' !== this.game_state ) {
			return;
		}

		// If hit left or right wall then don't die.
		if ( tile.index === this.RIGHT_WALL || tile.index === this.LEFT_WALL ) {
			return;
		}

		// Make sure it's the bottom of the player that is colliding.
		// We don't want to stop the player if they hit the side.
		if ( player.body.blocked.down ) {

			var player_width = 2;

			var right_collision = this.point_overlap_collision( player.x + player_width, player.y + 1 );
			var left_collision = this.point_overlap_collision( player.x - player_width, player.y + 1 );

			// Both collide so game over.
			if ( left_collision && right_collision ) {

				this.play_once( this.audio_crash );
				this.death_crash();

			}

			// Left collision only so nudge right.
			if ( left_collision ) {
				player.x += player_width;
			}

			// Right collision so nudge left.
			if ( right_collision ) {
				player.x -= player_width;
			}

			// Add back the players y velocity which gets removed on collision.
			// This helps to keep the game flowing nicely.
			player.body.velocity.y = player.body.velocity.old_y * 0.95;

		}

	},


	/**
	 * Pre collision checks to ensure the player is treated nicely.
	 *
	 * @param  {[type]} player [description]
	 * @param  {[type]} tile   [description]
	 * @return {[type]}        [description]
	 */
	player_collision_check: function( player, tile ) {

		// If in the air and then always return false for no collision.
		if ( this.player.z > 0 ) {
			return false;
		}

		// Default.
		return true;

	},


	/**
	 * Decide what to do based upon the tilemap topology.
	 *
	 * @param  {[type]} player [description]
	 * @param  {[type]} tile   [description]
	 * @return {[type]}        [description]
	 */
	player_heights_callback: function( player, tile ) {

		// Don't do this stuff if jumping.
		if ( this.player.z > 0 ) {
			return;
		}

		var p = player.position;
		var t = {
			x: tile.worldX,
			y: tile.worldY,
			tile_x: tile.x,
			tile_y: tile.y
		};

		if ( tile.index > 0 ) {
			this.debug_tile.x = t.x;
			this.debug_tile.y = t.y;
		}

		this.player_height = 0;

		if ( tile.index <= 0 ) {
			return;
		}

		// index offset for simpler maths.
		var index = 1024 - 32;

		switch ( tile.index ) {

			case ( index ):

				this.player_height = 3;

				break;

			case ( index - 1 ):

				this.player_height = 2;

				break;

			case ( index - 2 ):

				this.player_height = 1;

				break;

			// Water.
			case ( this.TILE_WATER ):

				var player_size = 2;

				if ( ( p.y - player_size ) > t.y && ( p.y + player_size ) < ( t.y + this.tile_size ) ) {

					// Nest the checks so that we don't have to do them if the first is false.
					// Check left.
					if ( this.point_overlap_water( p.x - player_size, p.y ) ) {

						// Check right.
						if ( this.point_overlap_water( p.x + player_size, p.y ) ) {

							this.play_once( this.audio_splash );
							this.death_drown();

						}

					}

				}

				this.player_trail.on = false;

				break;

			// Speed up.
			case ( index - 4 ):

				this.player.body.velocity.y += 1;

				break;

			// Weeeeeeh.
			case ( index - 5 ):

				this.player.body.velocity.y += 1.5;
				this.player_trail_frame = 400;

				this.play_once( this.audio_weeeee );

				break;


			// No trails.
			case ( index - 6 ):

				this.player_trail.on = false;

				break;

			// Super speed.
			case ( index - 7 ):

				this.player.body.velocity.y += 2;

				break;


			// reset stuff if required.
			default:

				break;

		}

	},


	/**
	 * Does the x, y position overlap water.
	 *
	 * @param  {int} x X coordinate to check.
	 * @param  {int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_water: function( x, y ) {

		return this.point_overlap( x, y, this.layer_heights, this.TILE_WATER );

	},


	/**
	 * Does the x, y position collide with anything?
	 * Ignores side only tiles.
	 */
	point_overlap_collision: function( x, y ) {

		return this.point_overlap( x, y, this.layer_collision, this.TILE_COLLISION );

	},


	/**
	 * Does the specified point overlap the specified tile type on the specified tile layer?
	 *
	 * @param  {int} x          X pixel coordinate to check.
	 * @param  {int} y          Y pixel coordinate to check.
	 * @param  {object} tile_layer Tile layer to check against.
	 * @param  {int} tile_index Tile index we are looking for.
	 * @return {bool}
	 */
	point_overlap: function( x, y, tile_layer, tile_index ) {

		// Make sure the tile index, and layer are set.
		if ( !tile_index || !tile_layer ) {
			return false;
		}

		// Get tile at specified coordinates.
		var tiles = tile_layer.getTiles( x, y, 0, 0 );

		// No tiles found?
		if ( 0 === tiles.length ) {
			return false;
		}

		// If the tile index is the desired tile type then return true.
		if ( tiles[ 0 ].index && tile_index === tiles[ 0 ].index ) {
			return true;
		}

		// If we got this far then it's not a match.
		return false;

	},


	/**
	 * Load level
	 */
	load_map: function() {

		// setup map
		this.map = game.add.tilemap( 'map1' );
		this.map.addTilesetImage( 'ski-terrain' );
		this.map.setCollisionBetween( 1, 9999, true, 'collision' );

		// add map layers
		this.layer = this.map.createLayer( 'tiles' );
		this.layer.resizeWorld();
		this.layer_details = this.map.createLayer( 'details' );
		this.layer_collision = this.map.createLayer( 'collision' );
		this.layer_heights = this.map.createLayer( 'height' );

		if ( !this.debug ) {

			this.layer_collision.visible = false;
			this.layer_heights.visible = false;

		}

		// add layers to group so they display in the correct order
		this.groupLevel.add( this.layer );
		this.groupLevel.add( this.layer_details );
		this.groupLevel.add( this.layer_collision );

		this.setTileCollision(
			this.layer_collision,
			this.RIGHT_WALL,
			{
				top: false,
				right: true,
				bottom: false,
				left: false
			}
		)

		this.setTileCollision(
			this.layer_collision,
			this.LEFT_WALL,
			{
				top: false,
				right: false,
				bottom: false,
				left: true
			}
		)


		// position player
		var player_position = this.findObjectsByType( 'start', this.map, 'objects' );

		if ( player_position[ 0 ] ) {

			// use the first result - there should only be 1 start point per level
			// if there isn't we'll just ignore the others
			this.player.x = parseInt( player_position[ 0 ].x + this.half_tile_size );
			this.player.y = parseInt( player_position[ 0 ].y );

			// position camera
			this.camera_movements();

		}

		// finish zone.
		var game_end = this.findObjectsByType( 'finish', this.map, 'objects' );

		if ( game_end[ 0 ] ) {

			this.finish_region = {
				x: parseInt( game_end[ 0 ].x ),
				y: parseInt( game_end[ 0 ].y ) + this.tile_size,
				w: parseInt( game_end[ 0 ].width ),
				h: parseInt( game_end[ 0 ].height ),
				finish_line: parseInt( game_end[ 0 ].y ) + this.tile_size
			};

		}

		// start zone.
		var game_start = this.findObjectsByType( 'start_zone', this.map, 'objects' );

		if ( game_start[ 0 ] ) {

			this.start_region = {
				x: parseInt( game_start[ 0 ].x ),
				y: parseInt( game_start[ 0 ].y ) + this.tile_size,
				w: parseInt( game_start[ 0 ].width ),
				h: parseInt( game_start[ 0 ].height ),
				start_line: parseInt( game_start[ 0 ].y ) + this.tile_size + parseInt( game_start[ 0 ].height )
			};

		}

	},


	/**
	 * Find objects in a Tiled layer that contain a property called "type" equal to a certain value
	 *
	 * @param   string     type   The object type to find, as specified in the map file
	 * @param   object     map    Tilemap bject
	 * @param   string     layer  Key for object layer to search
	 * @returns array      List of objects
	 */
	findObjectsByType: function( type, map, layer ) {

		var result = new Array();

		map.objects[ layer ].forEach(
			function( element ) {

				if ( typeof element.properties !== 'undefined' ) {

					if ( typeof element.properties.type !== 'undefined' && element.properties.type === type ) {

						//Phaser uses top left, Tiled bottom left so we have to adjust the y position
						//also keep in mind that the cup images are a bit smaller than the tile which is 16x16
						//so they might not be placed in the exact pixel position as in Tiled
						element.y -= map.tileHeight;
						result.push( element );

					}

				}
			}
		);

		return result;

	},


	/**
	 * Set tile collision properties.
	 *
	 * Allows collisions on a single side of the tile.
	 *
	 * @param  {object} 	mapLayer The map layer to scan.
	 * @param  {int} 		id       The id of the tile to apply the collision to.
	 * @param  {directions} dirs     An object with the direction settings desired.
	 */
	setTileCollision: function( mapLayer, id, dirs ) {

		// get the 2-dimensional tiles array for this layer
		var d = mapLayer.map.layers[ mapLayer.index ].data;

		for ( var i = 0; i < d.length; i++ ) {

			for ( var j = 0; j < d[ i ].length; j++ ) {

				var t = d[ i ][ j ];

				if ( id === t.index ) {

					t.collideUp = dirs.top;
					t.collideDown = dirs.bottom;
					t.collideLeft = dirs.left;
					t.collideRight = dirs.right;

					t.faceTop = dirs.top;
					t.faceBottom = dirs.bottom;
					t.faceLeft = dirs.left;
					t.faceRight = dirs.right;

				}

			}

		}

	},


	/**
	 * Release confetti in the home to make it a happier place
	 */
	house_party: function() {

		this.confetti = game.add.emitter( this.finish_region.x + ( this.finish_region.w / 2 ), this.finish_region.y - this.tile_size, 100 );
		this.confetti.makeParticles( 'confetti', [ 0, 1, 2, 3 ] );
		this.confetti.y = this.confetti.y + ( this.tile_size * 2 );
		this.confetti.width = this.finish_region.w * 1.2;
		this.confetti.height = this.tile_size;
		this.confetti.setYSpeed( 20, 40 );
		this.confetti.setXSpeed( 0, 0 );
		this.confetti.setRotation( 0, 0 );
		this.confetti.gravity = 0;
		this.groupElements.add( this.confetti );

		this.confetti.start( false, 1500, 70 );

	},


	/**
	 * Game completed. Now we can stop the timer and let the user wander around the world
	 */
	game_finished: function() {

		this.timer.pause();

	},


	/**
	 * Character drown in water
	 */
	death_drown: function() {

		this.player_image.animations.play( 'drown' );

		this.player.y = ( ( this.player.y / this.tile_size ) * this.tile_size ) + this.half_tile_size;
		this.player_shadow.visible = false;

		this.game_lost();

	},


	/**
	 * Crash into a tree.
	 */
	death_crash: function() {

		this.player_image.animations.play( 'die' );

		game.camera.shake( 0.01, 150 );

		this.game_lost();

	},


	/**
	 * Game over - have to try again
	 */
	game_lost: function() {

		this.play_once( this.audio_lose );
		this.audio_theme.fadeOut();

		this.game_state = 'lose';

		this.player.alive = false;
		this.player.body.enable = false;

		this.game_over_panel.frame = 1;

		game.add.tween( this.game_over_panel ).to(
			{ y: 64 - this.game_over_panel.height },
			1100,
			Phaser.Easing.Bounce.Out,
			true
		);

	},


	/**
	 * Update the player graphic when they cross the finish line.
	 */
	game_win: function() {

		this.player.body.velocity.x = this.player.body.velocity.x * 0.96;
		this.player.body.velocity.y = this.player.body.velocity.y * 0.955;

		if ( this.player.body.velocity.y < 0.1 ) {

			if ( this.player.body.enable ) {

				this.player.body.enable = false;
				this.player.body.velocity.z = 0;

				this.player_image.animations.play( 'celebrate' );

			}

		} else {

			this.player_image.animations.play( 'slow' );

		}

	},


	/**
	 * Sort out buttons at the end of the game.
	 */
	game_over_input: function( sprite, event ) {

		if ( event.x < 32 ) {

			game.state.start( 'menu' );

		}

		if ( event.x > 32 ) {

			var message = 'I played Pixel Peak';

			if ( 'lose' === this.game_state ) {
				message = 'I skiied [distance] meters in [time-elapsed] in Pixel Peak!';
			}

			if ( 'win' === this.game_state ) {
				message = 'I completed Pixel Peak, the tiny skiing game, in [time-elapsed]';
			}

			this.share_button( message );

		}

	},


	/**
	 * update game settings
	 */
	game_update: function() {

		this.player_image.x = Math.round( this.player.x );
		this.player_image.y = Math.round( this.player.y );

		this.player_trail.x = this.player_image.x;
		this.player_trail.y = this.player_image.y - 3;

		if ( this.debug ) {

			this.debug_player.x = this.player_image.x - 1;
			this.debug_player.y = this.player_image.y - 1;

		}

		// Ensure confetti is displayed on whole pixels.
		if ( this.confetti ) {

			this.confetti.forEach(
				function( item ) {
					item.x = Math.round( item.x );
					//item.y = Math.round( item.y );
				}
			);

		}

		if ( this.player_trail && this.player_trail_frame > 0 ) {

			this.player_trail.forEach(
				function( item ) {
					if ( item.lifespan > 999 ) {
						item.frame = 1;
					}
				}
			);

			this.player_trail_frame -= game.time.elapsed;

		}

		this.shadow_movements();

		game.camera.x = Math.round( game.camera.x );
		game.camera.y = Math.round( game.camera.y );

	},


	/**
	 * Apply render time effects.
	 * @return {[type]} [description]
	 */
	render: function() {

		if ( this.debug ) {

			game.debug.body( this.player );
			game.debug.geom( this.debug_tile, 'rgba(200,0,0,0.5)' );
			game.debug.geom( this.debug_player, 'rgba(0,255,255,1)' );

			var rect = new Phaser.Rectangle( this.finish_region.x, this.finish_region.y, this.finish_region.w, this.finish_region.h );
			game.debug.geom( rect, 'rgba(255,255,0,0.5)' );

			var rect = new Phaser.Rectangle( this.start_region.x, this.start_region.y, this.start_region.w, this.start_region.h );
			game.debug.geom( rect, 'rgba(255,255,0,0.5)' );

		}

	}

};


function smooth( current, target, smoothing ) {

	return current + ( ( target - current ) / smoothing );

}
